

































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class AclAccounts extends Vue {

    private deletingAccountIds: string[] = [];

    public isAccountDeleting(id: string): boolean {
        return this.deletingAccountIds.includes(id);
    }

    public async deleteAccount(id: string): Promise<void> {
        if (!confirm(`Are you sure, you want to delete account with ID ${id}?`)) {
            return;
        }
        this.deletingAccountIds.push(id);
        await this.$locator.aclManagement.deleteAccount(id);
        const index = this.deletingAccountIds.findIndex((innerId) => {
            return innerId === id;
        });
        this.deletingAccountIds.splice(index, 1);
    }
}
